const DEFAULT_LIFE_EXPECTANCY_YEARS = 80;

export function calculateRemainingYears(
  ageYears: number,
  lifeExpectancyYears: number = DEFAULT_LIFE_EXPECTANCY_YEARS,
): number {
  return Math.max(0, lifeExpectancyYears - ageYears);
}
